/* TAMA GEORGINA - chrome JS (bandeau defilant + fix reassurance + surbrillance retour PDP) - brouillon uniquement */
(function(){
  /* ===== BANDEAU DEFILANT ===== */
  var MSGS=[
    `Livraison en point relais offerte dès 69 €`,
    `Nouveau drop chaque mercredi 18h00`,
    `−10 % sur ta 1re commande avec BIENVENUE10`,
    `Paiement en 4× sans frais`,
    `Retour offert en avoir`,
    `Boutique & e-shop · Quimperlé, Bretagne`
  ];
  function buildTicker(bar){
    if(bar.getAttribute('data-tama-ticker'))return;
    bar.setAttribute('data-tama-ticker','1');
    var track=document.createElement('div');track.className='tama-ticker__track';
    for(var c=0;c<2;c++){for(var i=0;i<MSGS.length;i++){var s=document.createElement('span');s.textContent=MSGS[i];track.appendChild(s);}}
    var wrap=document.createElement('div');wrap.className='tama-ticker';wrap.appendChild(track);
    bar.innerHTML='';bar.appendChild(wrap);bar.style.opacity='1';
  }
  function runTicker(){var b=document.querySelectorAll('.topheader');for(var i=0;i<b.length;i++)buildTicker(b[i]);}

  /* ===== FIX REASSURANCE : neutraliser le script legacy qui reecrit la 1ere ligne ===== */
  function fixReassure(){
    var first=document.querySelector('.tama-reassure > div:first-child > span');
    if(!first || first.getAttribute('data-tama-fix'))return;
    first.setAttribute('data-tama-fix','1');
    var STATIC=`Point relais offert dès 69 €`;
    function reset(){ if((first.textContent||'').trim()!==STATIC){ first.textContent=STATIC; } }
    reset();
    try{ new MutationObserver(reset).observe(first,{childList:true,subtree:true,characterData:true}); }catch(e){}
  }

  /* ===== FICHE PRODUIT : surligner « offert en avoir » en rose dans l'encart retour ===== */
  function hlRetour(){
    if(!document.body || !document.body.classList.contains('template-product'))return;
    var box=document.querySelector('.tama-retour-pdp');
    if(!box || box.getAttribute('data-tama-hl'))return;
    /* tout le bloc est cliquable -> page Retours (le lien interne garde son comportement) */
    if(!box.getAttribute('data-tama-link')){ box.setAttribute('data-tama-link','1');
    box.setAttribute('role','link'); box.tabIndex=0; box.setAttribute('aria-label','Retour offert en avoir : comment ca marche');
    box.addEventListener('click',function(e){ if(e.target.closest('a')) return; location.href='/pages/retours'; });
    box.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); location.href='/pages/retours'; } });
    }
    var it=document.createNodeIterator(box,NodeFilter.SHOW_TEXT,null);
    var n;
    while(n=it.nextNode()){
      var m=n.nodeValue.match(/offert en avoir/i);
      if(m){
        var before=n.nodeValue.slice(0,m.index), after=n.nodeValue.slice(m.index+m[0].length);
        var frag=document.createDocumentFragment();
        if(before)frag.appendChild(document.createTextNode(before));
        var em=document.createElement('em');em.className='tama-hl';em.textContent=m[0];
        frag.appendChild(em);
        if(after)frag.appendChild(document.createTextNode(after));
        n.parentNode.replaceChild(frag,n);
        box.setAttribute('data-tama-hl','1');
        return;
      }
    }
  }

  function run(){runTicker();fixReassure();hlRetour();}
  window.addEventListener('tama-ticker-rebuild',runTicker);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  setTimeout(run,600);setTimeout(run,1600);
})();

/* ===== MODE EVENEMENT DU DROP (30/09/2026, demande Jerome : retrouver le cote « vivant / pulse evenement » de l'ancien theme) =====
   Uniquement dans la fenetre de l'evenement (heure de Paris) -> le reste de la semaine le site reste calme (lecon de mai 2026 :
   une urgence affichee toute la semaine faisait attendre le drop au lieu d'acheter).
   - mercredi 14h30 -> 18h00 : bandeau du haut = « Drop aujourd'hui 18h00 · dans 1 h 37 » (compte a rebours en direct, point qui pulse),
     clic = rappel agenda ; le bouton « Decouvrir les nouveautes » de l'accueil pulse avec une etiquette « des 18h00 ».
   - mercredi 18h00 -> vendredi 18h00 : bandeau = « Le drop est en ligne · decouvre les nouveautes » (lien Nouveautes) ;
     le bouton devient « Decouvrir le nouveau drop » (halo terracotta qui pulse) -> 1 clic = la nouvelle collection.
   (30/09 : pastille retiree de la grande photo a la demande de Jerome, la photo n'etant pas forcement une piece du drop.)
   - bascule toute seule a 18h00 pile, sans recharger (verification chaque seconde).
   TOGGLE semaine sans drop : passer TAMA_DROP_ON a false.
   30/09 (Jerome) : animation portee par le BOUTON seulement -> bandeau du haut inchange (TAMA_BAR_ON = false ; true pour le reactiver). */
(function(){
  var TAMA_DROP_ON = true;
  var TAMA_BAR_ON = false;
  if(!TAMA_DROP_ON) return;
  var DAYS={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6};
  function paris(){
    try{
      var f=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Paris',weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      var o={};f.formatToParts(new Date()).forEach(function(p){o[p.type]=p.value;});
      return {d:DAYS[o.weekday],h:+o.hour,m:+o.minute,s:+o.second};
    }catch(e){return null;}
  }
  function state(){
    var t=paris(); if(!t) return null;
    var mn=t.h*60+t.m;
    if(t.d===3 && mn>=870 && mn<1080) return {k:'pre',left:1080*60-(mn*60+t.s)};
    if((t.d===3 && mn>=1080) || t.d===4 || (t.d===5 && mn<1080)) return {k:'live'};
    return null;
  }
  function p2(n){return n<10?'0'+n:''+n;}
  function cd(sec){
    if(sec>=3600){var h=Math.floor(sec/3600),m=Math.floor((sec%3600)/60);return 'dans '+h+' h '+p2(m);}
    if(sec>=600) return 'dans '+Math.ceil(sec/60)+' min';
    return 'dans '+p2(Math.floor(sec/60))+':'+p2(sec%60);
  }
  function css(){
    if(document.getElementById('tama-ev-css'))return;
    var s=document.createElement('style');s.id='tama-ev-css';
    s.textContent=
    "html body .topheader .tama-evbar{display:flex!important;align-items:center;justify-content:center;gap:9px;width:100%;padding:0 12px;text-decoration:none!important;color:#F4F2F3!important;cursor:pointer;white-space:nowrap;overflow:hidden}"+
    "html body .topheader .tama-evbar b{color:#E8B36E!important;font-weight:800!important;font-family:'Manrope',sans-serif!important;font-size:12px!important;letter-spacing:.1em!important;text-transform:uppercase!important}"+
    "html body .topheader .tama-evbar .tama-evbar__cd{font-variant-numeric:tabular-nums;color:#F4F2F3!important}"+
    "html body .topheader .tama-evbar .tama-evbar__sep{color:#E8B36E!important}"+
    "html body .topheader .tama-evbar .tama-evbar__more{text-decoration:underline!important}"+
    "html body .topheader .tama-evbar .tama-evbar__short{display:none!important}"+
    ".tama-evbar__dot{flex:0 0 8px;width:8px;height:8px;border-radius:50%;background:#E8B36E;box-shadow:0 0 0 0 rgba(232,179,110,.7);animation:tamaEvPulse 1.6s ease-out infinite}"+
    "html body .tama-hero__cta a.tama-ev-btn{position:relative!important;overflow:visible!important;gap:10px!important;white-space:nowrap!important}"+
    "html body .tama-hero__cta a.tama-ev-btn:after{content:'';position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:tamaEvHalo 1.8s ease-out infinite}"+
    "html body .tama-hero__cta a.tama-ev-btn .tama-ev-btn__chip{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;border-radius:999px;background:rgba(232,179,110,.16);color:#E8B36E!important;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;line-height:1;white-space:nowrap;flex:0 0 auto}"+
    "html body .tama-hero__cta a.tama-ev-btn .tama-ev-btn__chip i,html body .tama-hero__cta a.tama-ev-btn .tama-ev-btn__dot{width:7px;height:7px;border-radius:50%;background:#E8B36E;display:inline-block;animation:tamaEvPulse 1.6s ease-out infinite}"+
    "html body .tama-hero__cta a.tama-ev-btn.is-live:after{animation-duration:1.3s}"+
    "@keyframes tamaEvPulse{0%{box-shadow:0 0 0 0 rgba(232,179,110,.7)}70%{box-shadow:0 0 0 8px rgba(232,179,110,0)}100%{box-shadow:0 0 0 0 rgba(232,179,110,0)}}"+
    "@keyframes tamaEvHalo{0%{box-shadow:0 0 0 0 rgba(196,104,59,.6)}70%{box-shadow:0 0 0 14px rgba(196,104,59,0)}100%{box-shadow:0 0 0 0 rgba(196,104,59,0)}}"+
    "@media (max-width:749px){html body .tama-hero__cta a.tama-ev-btn{padding-left:18px!important;padding-right:18px!important}html body .tama-hero__cta a.tama-ev-btn .tama-ev-btn__des{display:none}html body .topheader .tama-evbar .tama-evbar__more,html body .topheader .tama-evbar .tama-evbar__long{display:none!important}html body .topheader .tama-evbar .tama-evbar__short{display:inline!important}}"+
    "@media (prefers-reduced-motion:reduce){.tama-evbar__dot,.tama-ev-btn:after,.tama-ev-btn__dot,.tama-ev-btn__chip i{animation:none!important}}";
    document.head.appendChild(s);
  }
  var cur='';
  function bar(st){
    var bars=document.querySelectorAll('.topheader'); if(!bars.length) return;
    for(var i=0;i<bars.length;i++){
      var b=bars[i], el=b.querySelector('.tama-evbar');
      if(b.getAttribute('data-tama-ev')!==st.k || !el){
        b.setAttribute('data-tama-ev',st.k);
        if(st.k==='pre'){
          b.innerHTML="<a class='tama-evbar tama-remind-open' href='/collections/nouveautes' aria-label='Drop aujourd hui a 18h00 : cree ton rappel'><i class='tama-evbar__dot' aria-hidden='true'></i><b>Drop aujourd'hui 18h00</b><span class='tama-evbar__sep'>·</span><span class='tama-evbar__cd'></span><span class='tama-evbar__sep tama-evbar__more'>·</span><span class='tama-evbar__more'>Active le rappel</span></a>";
        }else{
          b.innerHTML="<a class='tama-evbar' href='/collections/nouveautes'><i class='tama-evbar__dot' aria-hidden='true'></i><b>Le drop est en ligne</b><span class='tama-evbar__sep'>·</span><span class='tama-evbar__long'>Voir les nouveautés →</span><span class='tama-evbar__short'>Voir →</span></a>";
        }
        b.style.opacity='1';
        el=b.querySelector('.tama-evbar');
      }
      if(st.k==='pre'){var c=el.querySelector('.tama-evbar__cd'); if(c) c.textContent=cd(st.left);}
    }
  }
  function btn(st){
    var a=document.querySelector('.tama-hero__cta a.tama-btn--lg'); if(!a) return;
    if(!a.getAttribute('data-tama-orig')) a.setAttribute('data-tama-orig',a.innerHTML);
    if(a.getAttribute('data-k')===st.k) return;
    a.setAttribute('data-k',st.k);
    a.classList.add('tama-ev-btn'); a.classList.toggle('is-live',st.k==='live');
    if(st.k==='pre'){ a.innerHTML="Découvrir les nouveautés <span class='tama-ev-btn__chip'><i aria-hidden='true'></i><span class='tama-ev-btn__des'>dès </span>18h00</span>"; }
    else { a.innerHTML="<span class='tama-ev-btn__dot' aria-hidden='true'></span>Découvrir le nouveau drop"; }
  }
  function restore(){
    var bars=document.querySelectorAll('.topheader[data-tama-ev]');
    for(var i=0;i<bars.length;i++){ bars[i].removeAttribute('data-tama-ev'); bars[i].removeAttribute('data-tama-ticker'); }
    var a=document.querySelectorAll('a.tama-ev-btn'); for(var j=0;j<a.length;j++){ var o=a[j].getAttribute('data-tama-orig'); if(o) a[j].innerHTML=o; a[j].classList.remove('tama-ev-btn','is-live'); a[j].removeAttribute('data-k'); }
    if(bars.length) setTimeout(function(){ try{ window.dispatchEvent(new Event('tama-ticker-rebuild')); }catch(e){} },0);
  }
  function tick(){
    var st=state();
    if(!st){ if(cur){ cur=''; restore(); } return; }
    cur=st.k; css(); if(TAMA_BAR_ON) bar(st); btn(st);
  }
  function start(){ tick(); setInterval(tick,1000); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setTimeout(start,700); }); else setTimeout(start,700);
})();
